import HBIcon from "@/components/HBIcon";
import HBTabButton from "@/components/HBTabButton";
import UserList from "@/components/UserList";
import { getFavoriteUsers } from "@/services";
import pvTracker from "@/tracker/report/pvTracker";
import getPageData from "@/tracker/shared/getPageData";
import useRequest from "@/utils/useReq";
import { useSetState } from "ahooks";
import { useRouter } from "next/router";
import { useCallback, useEffect, useRef, useState } from "react";
import { Else, If, Then } from "react-if";
import styles from "./index.module.less";

const cardTypeOptions = [
  { name: <HBIcon className={styles.icon} type="ic_widgets" />, value: "card" },
  {
    name: <HBIcon className={styles.icon} type="ic_listview" />,
    value: "line",
  },
];

export default function FavoriteUserList({ serverUserList }) {
  const router = useRouter();
  const { urlname } = router.query;

  const [query, setQuery] = useSetState({
    max: serverUserList?.length
      ? serverUserList[serverUserList.length - 1]?.seq
      : 0,
    urlname: "",
  });
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState(serverUserList || []);
  const [cardType, setCardType] = useState("card");
  const initRef = useRef(!serverUserList);
  useRequest(
    async () => {
      const { max, urlname } = query;

      if (!urlname) {
        return;
      }

      const result = await getFavoriteUsers({
        urlname,
        limit: 20,
        ...(max ? { max } : null),
      });

      const users =
        result?.pusers.map((item) => ({
          ...item.user,
          seq: item.updated_at,
        })) || [];

      if (users.length <= 0) {
        setHasMore(false);
      }

      setDataSource(dataSource.concat(users));
    },
    {
      refreshDeps: [query],
    }
  );

  useEffect(() => {
    if (urlname) {
      setHasMore(true);
      if (initRef.current) {
        setDataSource([]);
        setQuery({
          urlname,
          max: 0,
        });
      } else {
        initRef.current = true;
        setQuery({
          urlname,
        });
      }
    }
  }, [urlname, setQuery]);

  const onLoadMore = useCallback(() => {
    if (dataSource.length > 0) {
      const last = dataSource[dataSource.length - 1];
      setQuery({
        max: last.seq,
      });
      pvTracker(getPageData());
    }
  }, [dataSource, setQuery]);

  const onCardTypeChange = useCallback((option) => {
    setCardType(option.value);
  }, []);

  return (
    <div className={styles.user}>
      <div className={styles.more}>
        <HBTabButton
          className={styles.tab}
          size="small"
          options={cardTypeOptions}
          value={cardType}
          onChange={onCardTypeChange}
        />
      </div>
      <If condition={dataSource.length > 0 || hasMore}>
        <Then>
          <UserList
            dataSource={dataSource}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
            type={cardType}
          />
        </Then>
        <Else>
          <div className={styles.empty}>暂无用户</div>
        </Else>
      </If>
    </div>
  );
}
